import WorkshopSelect from '../../workshop-select';
import WorkshopSelectItem from '../../workshops/workshop-select-item';
import orElse from 'volta/helpers/or-else';

import type { TemplateOnlyComponent } from '@ember/component/template-only';
import type { TWorkshopType } from 'volta/models/types/workshop.d';
import type { IJsonApiQuery } from 'volta/utils/api/jsonapi-types';

export interface ISkusWorkshopFilterDefinitionArgs {
  skuId?: string;
  warehouseId?: string;
  scenarioId?: string;
  workshopTypes?: TWorkshopType[];
  noMatchesMessage?: string;
  placeholder?: string;
  renderInPlace?: boolean;
  beforeQuery?: (query: IJsonApiQuery) => IJsonApiQuery;
}

const FiltersSkusWorkshopFilterComponent = <template>
  {{! @glint-nocheck: not typesafe yet }}
  <WorkshopSelect
    @values={{@values}}
    @onChange={{@onChange}}
    @workshopTypes={{@componentArgs.workshopTypes}}
    @warehouseId={{@componentArgs.warehouseId}}
    @scenarioId={{@componentArgs.scenarioId}}
    @beforeQuery={{@componentArgs.beforeQuery}}
    @selectedPath='code'
    @labelHidden={{true}}
    @fill={{true}}
    @multiple={{true}}
    @matchTriggerWidth={{true}}
    @noMatchesMessage={{@componentArgs.noMatchesMessage}}
    @placeholder={{@componentArgs.placeholder}}
    @renderInPlace={{orElse @componentArgs.renderInPlace @renderInPlace}}
    @dataName={{@name}}
    ...attributes
    as |item|
  >
    <WorkshopSelectItem @workshop={{item}} />
  </WorkshopSelect>
</template> satisfies TemplateOnlyComponent<ISkusWorkshopFilterDefinitionArgs>;

export default FiltersSkusWorkshopFilterComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Filters::SkusWorkshopFilter': typeof FiltersSkusWorkshopFilterComponent;
    'filters/skus-workshop-filter': typeof FiltersSkusWorkshopFilterComponent;
  }
}
